module.exports = __webpack_public_path__ + "spanio_logo.870736cad499da2563715698998058a3.png";